import * as React from 'react';
import { SVGProps } from 'react';
import styled from 'styled-components';

const SVG = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m3.92 13.414-.531.53.53-.53Zm8.16 0 .531.53-.53-.53Zm.358-7.32.693-.286-.693.287Zm-8.876 0 .693.288-.693-.287Zm8.355 2.391V10h1.5V8.485h-1.5Zm-3.25 4.765H7.333v1.5h1.334v-1.5ZM4.083 10V8.485h-1.5V10h1.5Zm1.538-5.227.08-.08-1.06-1.061-.08.08 1.06 1.061Zm4.677-.08.081.08 1.06-1.06-.08-.081-1.06 1.06Zm-4.596 0c.682-.682 1.14-1.14 1.528-1.435.37-.282.586-.346.77-.346v-1.5c-.644 0-1.176.27-1.68.654-.486.37-1.027.914-1.679 1.566l1.06 1.06Zm5.657-1.061c-.652-.652-1.193-1.195-1.68-1.566C9.177 1.68 8.645 1.412 8 1.412v1.5c.184 0 .4.064.77.346.387.296.846.753 1.528 1.434l1.06-1.06ZM7.333 13.25c-.964 0-1.611-.001-2.094-.066-.462-.062-.66-.17-.79-.3l-1.06 1.06c.455.456 1.022.642 1.65.726.606.082 1.373.08 2.294.08v-1.5ZM2.583 10c0 .922-.001 1.688.08 2.295.085.627.27 1.194.726 1.65l1.06-1.061c-.13-.13-.237-.328-.3-.79-.064-.482-.066-1.13-.066-2.094h-1.5Zm9.334 0c0 .964-.002 1.612-.067 2.095-.062.461-.17.659-.3.789l1.061 1.06c.456-.455.641-1.022.726-1.65.081-.606.08-1.372.08-2.294h-1.5Zm-3.25 4.75c.921 0 1.688.002 2.294-.08.628-.084 1.195-.27 1.65-.725l-1.06-1.061c-.13.13-.328.238-.79.3-.483.065-1.13.066-2.094.066v1.5Zm4.75-6.265c0-1.165.013-1.956-.286-2.677l-1.386.574c.158.381.172.816.172 2.103h1.5Zm-3.038-3.712c.91.91 1.208 1.227 1.366 1.609l1.386-.574c-.299-.721-.868-1.272-1.691-2.096l-1.061 1.061ZM4.083 8.485c0-1.287.014-1.722.172-2.103l-1.386-.574c-.299.72-.286 1.512-.286 2.677h1.5Zm.477-4.773c-.823.824-1.393 1.375-1.691 2.096l1.386.574C4.413 6 4.71 5.684 5.62 4.773l-1.06-1.06Z"
      fill="currentColor"
    />
    <path
      d="m1.333 8 3.334-3.333m10 3.333-3.334-3.333"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const StyledSvgHome = styled(SVG)`
  font-size: ${props => (props.fontSize ? props.fontSize : '1.6rem')};
  color: ${({ color, theme }) =>
    color ? color : theme.colors.neutralColors.charcoal};
  vertical-align: middle;
  shape-rendering: inherit;
  transform: translate3d(0, 0, 0);
`;
export default StyledSvgHome;
